module.exports = __webpack_public_path__ + "static/media/thumbnail_juniper.85f7feec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coverpageThemeThumbnails/thumbnail_juniper.jpg
// module id = 1336
// module chunks = 17